const base = {
    baseUrl: "https://www.xljyz525.cn",
    login: "/xljyz/manage/login.php",
    getBottleCount: "/xljyz/manage/getBottleCount.php",
    getBottle: "/xljyz/manage/getBottle.php",
    deleteBottle: "/xljyz/manage/deleteBottle.php",

    getDiaryCount: "/xljyz/manage/getDiaryCount.php",
    getDiary: "/xljyz/manage/getDiary.php",
    deleteDiary: "/xljyz/manage/deleteDiary.php",
    pushDiary: "/xljyz/manage/pushDiary.php",
    rejectDiary: "/xljyz/manage/rejectDiary.php",
    getDiaryCommentCount: "/xljyz/manage/getDiaryCommentCount.php",
    getDiaryComment: "/xljyz/manage/getDiaryComment.php",
    deleteDiaryComment: "/xljyz/manage/deleteDiaryComment.php",
    
    getMovieCount: "/xljyz/manage/getMovieCount.php",
    getMovie: "/xljyz/manage/getMovie.php",
    deleteMovie: "/xljyz/manage/deleteMovie.php",
    addMovie: "/xljyz/manage/addMovie.php",
    uploadMovieImage: "/xljyz/manage/uploadMovieImage.php",
    updateMovie: "/xljyz/manage/updateMovie.php",
    pushMovie: "/xljyz/manage/pushMovie.php",
    rejectMovie: "/xljyz/manage/rejectMovie.php",
    getMovieCommentCount: "/xljyz/manage/getMovieCommentCount.php",
    getMovieComment: "/xljyz/manage/getMovieComment.php",
    deleteMovieComment: "/xljyz/manage/deleteMovieComment.php",

    getMusicCount: "/xljyz/manage/getMusicCount.php",
    getMusic: "/xljyz/manage/getMusic.php",
    deleteMusic: "/xljyz/manage/deleteMusic.php",
    addMusic: "/xljyz/manage/addMusic.php",
    uploadMusicImage: "/xljyz/manage/uploadMusicImage.php",
    updateMusic: "/xljyz/manage/updateMusic.php",
    pushMusic: "/xljyz/manage/pushMusic.php",
    rejectMusic: "/xljyz/manage/rejectMusic.php",
    uploadMusic: "/xljyz/manage/uploadMusic.php",

    getBookCount: "/xljyz/manage/getBookCount.php",
    getBook: "/xljyz/manage/getBook.php",
    deleteBook: "/xljyz/manage/deleteBook.php",
    addBook: "/xljyz/manage/addBook.php",
    uploadBookImage: "/xljyz/manage/uploadBookImage.php",
    updateBook: "/xljyz/manage/updateBook.php",
    pushBook: "/xljyz/manage/pushBook.php",
    rejectBook: "/xljyz/manage/rejectBook.php",
    getBookCommentCount: "/xljyz/manage/getBookCommentCount.php",
    getBookComment: "/xljyz/manage/getBookComment.php",
    deleteBookComment: "/xljyz/manage/deleteBookComment.php",

    getQuestionaryCount: "/xljyz/manage/getQuestionaryCount.php",
    getQuestionary: "/xljyz/manage/getQuestionary.php",
    deleteQuestionary: "/xljyz/manage/deleteQuestionary.php",
    addQuestionary: "/xljyz/manage/addQuestionary.php",
    addQuestionaryResult: "/xljyz/manage/addQuestionaryResult.php",
    getQuestion: "/xljyz/manage/getQuestion.php",
    getQuestionaryResult: "/xljyz/manage/getQuestionaryResult.php",
    getQuestionaryDetail: "/xljyz/manage/getQuestionaryDetail.php",
    updateQuestionary: "/xljyz/manage/updateQuestionary.php",
    addQuestionaryCode: "/xljyz/manage/addQuestionaryCode.php",
    getQuestionaryRecord: "/xljyz/manage/getQuestionaryRecord.php",
    getTestUserCount: "/xljyz/manage/getTestUserCount.php",
    getTestUser: "/xljyz/manage/getTestUser.php",
    getUserTestResult: "/xljyz/manage/getUserTestResult.php",

    getArticleCount: "/xljyz/manage/getArticleCount.php",
    getArticle: "/xljyz/manage/getArticle.php",
    pushArticle: "/xljyz/manage/pushArticle.php",
    rejectArticle: "/xljyz/manage/rejectArticle.php",
    addArticle: "/xljyz/manage/addArticle.php",
    uploadArticleImage: "/xljyz/manage/uploadArticleImage.php",
    deleteArticle: "/xljyz/manage/deleteArticle.php",
    uploadArticleAudio: "/xljyz/manage/uploadArticleAudio.php",
    getArticleCommentCount: "/xljyz/manage/getArticleCommentCount.php",
    getArticleComment: "/xljyz/manage/getArticleComment.php",
    deleteArticleComment: "/xljyz/manage/deleteArticleComment.php",

    getCourseCount: "/xljyz/manage/getCourseCount.php",
    getCourse: "/xljyz/manage/getCourse.php",
    deleteCourse: "/xljyz/manage/deleteCourse.php",
    addCourse: "/xljyz/manage/addCourse.php",
    uploadCourseVideo: "/xljyz/manage/uploadCourseVideo.php",
    uploadCourseImage: "/xljyz/manage/uploadCourseImage.php",
    updateCourse: "/xljyz/manage/updateCourse.php",

    getPopularizationCount: "/xljyz/manage/getPopularizationCount.php",
    getPopularization: "/xljyz/manage/getPopularization.php",
    deletePopularization: "/xljyz/manage/deletePopularization.php",
    addPopularization: "/xljyz/manage/addPopularization.php",
    uploadPopularizationImage: "/xljyz/manage/uploadPopularizationImage.php",
    updatePopularization: "/xljyz/manage/updatePopularization.php",
    uploadPopularizationAudio: "/xljyz/manage/uploadPopularizationAudio.php",
    getPopularizationCommentCount: "/xljyz/manage/getPopularizationCommentCount.php",
    getPopularizationComment: "/xljyz/manage/getPopularizationComment.php",
    deletePopularizationComment: "/xljyz/manage/deletePopularizationComment.php",

    getSchoolCount: "/xljyz/manage/getSchoolCount.php",
    getSchool: "/xljyz/manage/getSchool.php",
    addSchool: "/xljyz/manage/addSchool.php",
    deleteSchool: "/xljyz/manage/deleteSchool.php",
    updateSchool: "/xljyz/manage/updateSchool.php",

    getClassCount: "/xljyz/manage/getClassCount.php",
    getClass: "/xljyz/manage/getClass.php",
    addClass: "/xljyz/manage/addClass.php",
    deleteClass: "/xljyz/manage/deleteClass.php",
    updateClass: "/xljyz/manage/updateClass.php",

    getUserCount: "/xljyz/manage/getUserCount.php",
    getUser: "/xljyz/manage/getUser.php",
    changeUserRole: "/xljyz/manage/changeUserRole.php",

    getAdminCount: '/xljyz/manage/getAdminCount.php',
    getAdmin: '/xljyz/manage/getAdmin.php',
    changeMemberInfo: '/xljyz/manage/changeMemberInfo.php',
    changePassword: '/xljyz/manage/changePassword.php',
    getAdminPassword: '/xljyz/manage/getAdminPassword.php',
    addMember: '/xljyz/manage/addMember.php',
    getMemberInfo: '/xljyz/manage/getMemberInfo.php',
    deleteMember: '/xljyz/manage/deleteMember.php',
    resetPassword: '/xljyz/manage/resetPassword.php',
    updateMember: '/xljyz/manage/updateMember.php',

    getRecommendCount: '/xljyz/manage/getRecommendCount.php',
    getRecommend: '/xljyz/manage/getRecommend.php',
    deleteRecommend: '/xljyz/manage/deleteRecommend.php',
    handleRecommend: '/xljyz/manage/handleRecommend.php',
    revokeRecommend: '/xljyz/manage/revokeRecommend.php',

    getStudentCount: '/xljyz/manage/getStudentCount.php',
    getTypeCount: '/xljyz/manage/getTypeCount.php',
    getOpinionCount: '/xljyz/manage/getOpinionCount.php',
    getOpinion: '/xljyz/manage/getOpinion.php',
    getAllOpinion: '/xljyz/manage/getAllOpinion.php',
    getReportCount: '/xljyz/manage/getReportCount.php',
    getReport: '/xljyz/manage/getReport.php',
    handleReport: '/xljyz/manage/handleReport.php',
    revokeReport: '/xljyz/manage/revokeReport.php',

    addLoginRecord: '/xljyz/manage/addLoginRecord.php',
    getLoginRecordCount: '/xljyz/manage/getLoginRecordCount.php',
    getLoginRecord: '/xljyz/manage/getLoginRecord.php',
}

export default base